import React from 'react';

export default function AnimatedBackground() {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {/* Gradient orbs - positioned at edges to keep center clear */}
      <div className="absolute top-[-20%] left-[-15%] w-[500px] h-[500px] rounded-full bg-gradient-to-br from-primary/25 via-purple-500/15 to-transparent blur-3xl animate-blob" />
      <div className="absolute top-[30%] right-[-20%] w-[450px] h-[450px] rounded-full bg-gradient-to-bl from-purple-600/20 via-pink-500/12 to-transparent blur-3xl animate-blob animation-delay-2000" />
      <div className="absolute bottom-[-15%] left-[-10%] w-[400px] h-[400px] rounded-full bg-gradient-to-tr from-blue-500/15 via-primary/20 to-transparent blur-3xl animate-blob animation-delay-4000" />
      <div className="absolute bottom-[20%] right-[-15%] w-[350px] h-[350px] rounded-full bg-gradient-to-tl from-pink-500/15 via-purple-400/10 to-transparent blur-3xl animate-blob animation-delay-2000" />
      
      {/* Subtle grid pattern overlay */}
      <div 
        className="absolute inset-0 opacity-[0.015]"
        style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, rgba(255,255,255,0.4) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}
      />
    </div>
  );
}
